import React from "react";
import { A } from "hookrouter";

import styles from "./Navbar.module.css";

const NavbarLogo = () => {
  return (
    <li>
      <A className={styles.logoContainer} href="/">
        <div className={styles.logo}>Yazbie</div>
      </A>
    </li>
  );
};

export default NavbarLogo;
